import axios from "axios";
import { API_URL } from "../config";

const marketService = {
  // Stock Movers
  fetchStockMover: async (date) => {
    try {
      const response = await axios.get(`${API_URL}market-data`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching stock mover data:", error);
      throw error;
    }
  },

  // Advance Decline Trends
  fetchAdvanceDeclineTrends: async (date) => {
    try {
      const response = await axios.get(`${API_URL}advance-decline`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching advance decline trends:", error);
      throw error;
    }
  },

  // Sector Insights
  fetchSectorInsights: async (date) => {
    try {
      const response = await axios.get(`${API_URL}sector-insights`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching sector insights:", error);
      throw error;
    }
  },

  // Stock Insights
  fetchStockInsights: async (date) => {
    try {
      const response = await axios.get(`${API_URL}stock-insights`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching stock insights:", error);
      throw error;
    }
  },

  // Sectorwise Data
  fetchSectorwiseData: async (date) => {
    try {
      const response = await axios.get(`${API_URL}sectorwise-data`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching sectorwise data:", error);
      throw error;
    }
  },

  // Price Volume Movers
  fetchPriceVolumeMovers: async (date) => {
    try {
      const response = await axios.get(`${API_URL}price-volume`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching price volume movers:", error);
      throw error;
    }
  },

  // Intraday Analysis
  fetchIntradayAnalysis: async (date) => {
    try {
      const response = await axios.get(`${API_URL}intraday`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching intraday analysis:", error);
      throw error;
    }
  },

  // Options Trading
  fetchOptionsTrading: async (date) => {
    try {
      const response = await axios.get(`${API_URL}options`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching options trading data:", error);
      throw error;
    }
  },

  // IPO Insights
  fetchIPOInsights: async (date) => {
    try {
      const response = await axios.get(`${API_URL}ipo`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching IPO insights:", error);
      throw error;
    }
  },

  // Indices Movers
  fetchIndicesMovers: async (date) => {
    try {
      const response = await axios.get(`${API_URL}indices`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching indices movers:", error);
      throw error;
    }
  },

  // Trending Stocks
  fetchTrendingStocks: async (date) => {
    try {
      const response = await axios.get(`${API_URL}trending`, {
        params: { date },
      });
      return response.data.trending_now || [];
    } catch (error) {
      console.error("Error fetching trending stocks:", error);
      throw error;
    }
  },

  // Sector Performance
  fetchSectorPerformance: async (date) => {
    try {
      const response = await axios.get(`${API_URL}sector-performance`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching sector performance:", error);
      throw error;
    }
  },
};

export default marketService;
